import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import DarkStreetwearBanner from "./sections/DarkStreetwearBanner";
import EngineeredForExcellence from "./sections/EngineeredForExcellence";
import ImperialHallOfFame from "./sections/ImperialHallOfFame";
import WhyDiecloudIsTheRightPartner from "./sections/WhyDiecloudIsTheRightPartner";
import IndustryCollaborations from "./sections/IndustryCollaborations";
import BeginYourJourney from "./sections/BeginYourJourney";
import ShopnoFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <DarkStreetwearBanner />
      <EngineeredForExcellence />
      <ImperialHallOfFame />
      <WhyDiecloudIsTheRightPartner />
      <IndustryCollaborations />
      <BeginYourJourney />
      <ShopnoFooter />
    </div>;
}